import { render } from "./PlayerComponent.vue?vue&type=template&id=84f27850"
import script from "./PlayerComponent.vue?vue&type=script&lang=js"
export * from "./PlayerComponent.vue?vue&type=script&lang=js"

import "./PlayerComponent.vue?vue&type=style&index=0&id=84f27850&lang=css"

import exportComponent from "C:\\Users\\windows\\Documents\\GitHub\\ValoAssist_web - 복사본\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__